// Celular (web responsiva, < 768 px): barra de abas flutuante no rodapé (Figma 6.1).
import { useTranslation } from 'react-i18next';
import { useNav } from '../state/services';
import { Icon } from './Icon';
import { cls } from './NewTaskForm';
import { NAV_ITEMS } from './Sidebar';

export function MobileTabBar() {
  const { t } = useTranslation();
  const nav = useNav();
  return (
    <nav className="tabbar" aria-label={t('nav.label')} data-testid="tabbar">
      {NAV_ITEMS.map((item) => {
        const on = nav.view === item.view;
        return (
          <button key={item.view} type="button" className={cls('tabbar__item', on && 'is-active')} aria-current={on ? 'page' : undefined} aria-label={t(item.label)} onClick={() => nav.go(item.view)}>
            <span className="tabbar__icon">
              <Icon name={item.icon} size={16} />
            </span>
            {on && <span className="tabbar__label">{t(item.label)}</span>}
          </button>
        );
      })}
    </nav>
  );
}
